import type { ErrorInfo } from 'ably'

import { getEnvSegment } from 'src/utils/env'
import type { TranscriptConnectionErrorType } from 'src/models/TranscriptConnectionState'

import {
    ABLY_ACCESS_DENIED_RANGE_END,
    ABLY_ACCESS_DENIED_RANGE_START,
    ABLY_AUTH_ERROR_RANGE_END,
    ABLY_AUTH_ERROR_RANGE_START,
} from './constants'

export const getErrorTypeFromAblyError = (error: ErrorInfo): TranscriptConnectionErrorType => {
    if (error.code >= ABLY_AUTH_ERROR_RANGE_START && error.code < ABLY_AUTH_ERROR_RANGE_END) {
        return 'auth_expired'
    }

    if (error.code >= ABLY_ACCESS_DENIED_RANGE_START && error.code < ABLY_ACCESS_DENIED_RANGE_END) {
        return 'access_denied'
    }

    return 'server_error'
}

// Ably may deliver binary message data as ArrayBuffer, Buffer, or Uint8Array
// depending on the transport.
export const coerceToUint8Array = (data: unknown): Uint8Array | null => {
    if (data instanceof Uint8Array) {
        return data
    }

    if (data instanceof ArrayBuffer) {
        return new Uint8Array(data)
    }

    if (typeof Buffer !== 'undefined' && Buffer.isBuffer(data)) {
        return new Uint8Array(data.buffer, data.byteOffset, data.byteLength)
    }

    return null
}

export const buildCrdtChannelName = (jobId: string, languageCode: string): string =>
    `transcript:${getEnvSegment()}:${jobId}:${languageCode}:crdt`
